document.addEventListener('DOMContentLoaded', function () {
  const blocks = document.querySelectorAll('.js-notices-block');
  console.log('notices', blocks)

  blocks.forEach((block) => {
    const items = block.querySelectorAll('.js-notice-item');
    const showMoreBtn = block.querySelector('.js-notices-show-more');
    const hideBtn = block.querySelector('.js-notices-hide');
    const initialCount = Number(block.dataset.initialCount) || 3;
    const batchSize = Number(block.dataset.batchSize) || 3;
    let visibleCount = initialCount;

    function updateButtons() {
      if (showMoreBtn) {
        showMoreBtn.classList.toggle('d-none', visibleCount >= items.length);
      }

      if (hideBtn) {
        hideBtn.classList.toggle('d-none', visibleCount <= initialCount);
      }
    }

    showMoreBtn?.addEventListener('click', function () {
      const nextCount = Math.min(visibleCount + batchSize, items.length);

      for (let i = visibleCount; i < nextCount; i++) {
        items[i].classList.remove('d-none');
      }

      visibleCount = nextCount;
      updateButtons();
    });

    hideBtn?.addEventListener('click', function () {
      for (let i = initialCount; i < items.length; i++) {
        items[i].classList.add('d-none');
      }

      visibleCount = initialCount;
      updateButtons();
    });

    updateButtons();
  });
});
